module.exports = __webpack_public_path__ + "a21f07ec79.png";